import { render, staticRenderFns } from "./BecomePartnerPage.vue?vue&type=template&id=5187b792&scoped=true&"
import script from "./BecomePartnerPage.vue?vue&type=script&lang=js&"
export * from "./BecomePartnerPage.vue?vue&type=script&lang=js&"
import style0 from "./BecomePartnerPage.vue?vue&type=style&index=0&id=5187b792&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5187b792",
  null
  
)

export default component.exports